var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "model-viewer",
    {
      ref: "modalViewer",
      attrs: {
        bounds: "tight",
        src: _vm.src,
        ar: "",
        "ar-modes": "webxr scene-viewer quick-look",
        "camera-controls": "",
        poster: "poster.png",
        "shadow-intensity": parseFloat(_vm.shadow_intensity),
        "shadow-softness": parseFloat(_vm.shadow_softness),
        autoplay: "",
        "environment-image": _vm.environment,
        "animation-name": _vm.animation,
        exposure: _vm.exposure == 0 ? 1 : _vm.exposure
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "progress-bar hide",
          attrs: { slot: "progress-bar" },
          slot: "progress-bar"
        },
        [_c("div", { staticClass: "update-bar" })]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6495d71e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6495d71e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/viewer.vue
// module id = null
// module chunks = 